import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '../services/analytics-api.service';
import type { AnalyticsQueryParams } from '../types/analytics.types';

export const fpClientActionsKeys = {
  all: ['analytics', 'fp-client-actions'] as const,
  list: (params?: AnalyticsQueryParams) => [...fpClientActionsKeys.all, 'list', params] as const,
};

export const useFPClientActionsData = (params?: AnalyticsQueryParams, enabled = true) => {
  return useQuery({
    queryKey: fpClientActionsKeys.list(params),
    queryFn: async () => {
      const response = await analyticsApi.getFPClientActions(params);
      return response.data;
    },
    staleTime: 30 * 60 * 1000,
    enabled,
  });
};
